export default __webpack_public_path__ + "static/media/logo_autorepair.560224b3.svg";